import { useQuery } from "react-query";
import QUERY_KEYS from "../queryKeys";
import {
  getChallengeDetails,
  getChallengeSubscriberAthleteList,
} from "./queryFunctions";
import commonConfig from "../config";

export const useChallengeDetails = (c_id, config = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.CHALLENGE_DETAILS, c_id],
    queryFn: () => getChallengeDetails({ c_id }),
    ...commonConfig,
    ...config,
  });

export const useChallengeSubscriberAthleteList = (
  challenge_id,
  page,
  limit,
  config = {}
) =>
  useQuery({
    queryKey: [QUERY_KEYS.CHALLENGE_DETAILS, challenge_id, page, limit],
    queryFn: () =>
      getChallengeSubscriberAthleteList({ challenge_id, page, limit }),
    ...commonConfig,
    ...config,
  });
